const PIXEL_ID = '1047173294591994'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

function loadPixelScript(): void {
  if (window.fbq) return

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    if (fbq!.callMethod) {
      fbq!.callMethod.apply(fbq, args)
    } else {
      fbq!.queue!.push(args)
    }
  } as Window['fbq']

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  fbq!.push = fbq
  fbq!.loaded = true
  fbq!.version = '2.0'
  fbq!.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)
}

/** Loads the Meta Pixel (once) and fires PageView + ViewContent on every mount. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  loadPixelScript()

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
  window.fbq?.('track', 'ViewContent', {
    content_name: 'Megapack Host Automático',
    content_type: 'product',
    content_ids: ['megapack-host-automatico'],
    value: 19,
    currency: 'USD',
  })
}

export function trackMetaEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}
